import { render, staticRenderFns } from "./devTests.vue?vue&type=template&id=45875214&scoped=true&"
import script from "./devTests.vue?vue&type=script&lang=js&"
export * from "./devTests.vue?vue&type=script&lang=js&"
import style0 from "./devTests.vue?vue&type=style&index=0&id=45875214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45875214",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
